<script setup>
import Dropdown from "primevue/dropdown";
import { defineEmits, defineProps, ref, watch } from "vue";
import { ACCEPTANCE_STATUS } from "@/components/MyStudents/MyStudentsAcceptance/utils";

const props = defineProps({
  status: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  dataTestId: {
    type: String,
    default: "status-dropdown",
  },
});

const dropdownOptions = () => {
  return Object.values(ACCEPTANCE_STATUS)
    .filter((status) => status !== ACCEPTANCE_STATUS.readyForReview)
    .map((status) => {
      return { name: status, status: status };
    });
};

const options = ref(dropdownOptions());

const emit = defineEmits(["openModal"]);
// eslint-disable-next-line vue/no-setup-props-destructure
const localStatus = ref(props.status);
const onChange = (event) => {
  emit("openModal", { status: event.value });
};

watch(
  () => props.status,
  (newVal) => {
    localStatus.value = newVal;
  },
);
</script>

<template>
  <Dropdown
    class="flex-1 w-full md:w-52 border-gray-300 !rounded-full !outline-none"
    :model-value="localStatus"
    :data-testid="dataTestId"
    :panel-class="['bg-white', 'z-[1050]']"
    :options="options"
    option-label="name"
    option-value="status"
    :append-to="`body`"
    :disabled="disabled"
    @change="onChange"
  />
</template>
